import React, { useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSnackbar } from "notistack";

const WizardFileUpload = ({
  setFileNames,
  fileNames,
  SelectedCategory,
  setSelectedCategory,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [showModal, setShowModal] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [editfetchedfiles, seteditFetchedFiles] = useState([]);

  const dropdownRefProbability = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefProbability.current &&
        !dropdownRefProbability.current.contains(event.target)
      ) {
        setShowCategoryDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const downloadFile = (file) => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name; // use file name from File object
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    enqueueSnackbar("File Downloaded successfully", {
      variant: "success",
    });
  };

  const handleDownload = (file) => {
    downloadFile(file);
  };

  const [existingNames, setExistingNames] = useState([]);

useEffect(() => {
  setExistingNames([
    ...fileNames,
    ...editfetchedfiles,
  ].map((f) => f.name ?? f.fileName));
}, [fileNames, editfetchedfiles]);


  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    // const maxSize = 2 * 1024 * 1024; // 2 MB
    const allowedFormats = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    if (!SelectedCategory) {
      enqueueSnackbar("Please select a category first", { variant: "error" });
      return;
    }

    const validFiles = [];

    selectedFiles.forEach((file) => {
      if (!allowedFormats.includes(file.type)) {
        enqueueSnackbar("Only PDF and DOC files are allowed", {
          variant: "error",
        });
        return;
      }
      if (existingNames.includes(file.name)) {
        enqueueSnackbar("File is already uploaded.", { variant: "error" });
        return;
      }

      const fileWithCategory = new File([file], file.name, {
        type: file.type,
        lastModified: file.lastModified,
      });
      fileWithCategory.selectedCategory = SelectedCategory;
      validFiles.push(fileWithCategory);
    });
    if (validFiles.length === 0) return;
    setFileNames((prev) => [...prev, ...validFiles]);
    seteditFetchedFiles((prev) => [
      ...prev,
      ...validFiles.map((f) => ({
        fileName: f.name,
        selectedCategory: f.selectedCategory,
        fileContent: "",
        isNew: true,
      })),
    ]);
    enqueueSnackbar("File uploaded successfully", { variant: "success" });
    setSelectedCategory("");
    e.target.value = null;
  };

  const handleFileDelete = (file) => {
  const fileName = file.fileName || file.name;

  setFileNames((prev) =>
    prev.filter((f) => (f.name ?? f.fileName) !== fileName)
  );

  seteditFetchedFiles((prev) => {
    const updated = prev.filter((f) => f.fileName !== fileName);
    return updated.length === 0 ? [] : updated;
  });

    enqueueSnackbar("File deleted successfully", {
      variant: "success",
    });
  };


  return (
    <div>
      <div className="mt-1">
        <button
          onClick={() => setShowModal(true)}
          className="text-[12px] px-2 py-1 bg-black hover:text-white border hover:bg-slate-800 border-black overflow-hidden shadow-md text-white rounded-lg"
        >
          Upload File
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex justify-center items-center z-50 bg-opacity-50 bg-black">
          <div className="w-[50%] bg-white shadow-lg rounded-lg p-6">
            {/* Popup content... */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-bold">Attachments</h2>
              <button
                className="text-gray-500 hover:text-black"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
            <div className="flex gap-2">
              {/* Category Dropdown */}
              <div className="relative bg-white">
                <div
                  ref={dropdownRefProbability}
                  className=" flex  p-0  rounded-xl align-middle text-[12px]"
                >
                  <button
                    type="button"
                    onClick={() =>
                      setShowCategoryDropdown(!showCategoryDropdown)
                    }
                    className="border relative w-24 border-gray-400 text-nowrap rounded-md p-2  shadow-md overflow-hidden bg-gray-200 outline-none"
                  >
                    <p className="text-left">
                      {SelectedCategory ? SelectedCategory : "Category"}
                    </p>
                    <ExpandMoreIcon
                      color="white"
                      className="absolute cursor-pointer right-0 top-2 bg-gray-200"
                    />
                  </button>

                  {showCategoryDropdown && (
                    <div
                      style={{ zIndex: 9999 }}
                      className="absolute top-full left-0 w-40 p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                    >
                      <div
                        className="p-1 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCategory("Quote");
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }}
                      >
                        Quote
                      </div>
                      <div
                        className="p-1 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCategory("Purchase Order");
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }}
                      >
                        Purchase Order
                      </div>
                      <div
                        className="p-1 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCategory("Contract");
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }}
                      >
                        Contract
                      </div>
                      <div
                        className="p-1 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCategory("Communication");
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }}
                      >
                        Communication
                      </div>
                      <div
                        className="p-1 hover:bg-gray-200 cursor-pointer"
                        onClick={() => {
                          setSelectedCategory("Miscellaneous");
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }}
                      >
                        Miscellaneous
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* File Upload btn */}
              <div className="flex items-center">
                {/* Upload input */}
                <input
                  type="file"
                  multiple
                  id={`fileUpload`}
                  className="hidden"
                  onChange={(e) => handleFileChange(e)}
                  disabled={!SelectedCategory}
                />

                <label
                  htmlFor="fileUpload"
                  className={`text-xs p-2 rounded-md ${!SelectedCategory
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-gray-800 text-white hover:text-black hover:bg-gray-300 cursor-pointer"
                    }`}
                >
                  Upload File
                </label>

                <p className="truncate text-xs pl-1">
                  {fileNames?.name || "No file selected"}
                </p>
                <div className="flex gap-2 text-red-500 text-[12px] pl-3">
                  <p> only .pdf and .docx allowed</p>
                </div>
              </div>
            </div>
            {/* Table */}
            <div className="text-[13px]">
              <div>
                <div className="border-b flex w-full">
                  <div className="py-2 px-4 w-[15%]">Sr. No.</div>
                  <div className="py-2 px-4 w-[40%]">File Name</div>
                  <div className="py-2 px-4 text-center w-[15%]">Category</div>
                  <div className="py-2 px-4 text-center w-[15%]">Download</div>
                  <div className="py-2 px-4 text-center w-[15%]">Delete</div>
                </div>
              </div>
              <div>
                {fileNames.map((file, index) => (
                  <div className="border-b flex w-full" key={file.id ?? index}>
                    <div className="py-2 px-4 w-[15%]">{index + 1}</div>
                    <div className="py-2 px-4 w-[40%] truncate overflow-hidden">{file.filename || file.name}</div>
                    <div className="py-2 px-4 w-[15%] text-center truncate">
                      {file.category || file.selectedCategory}
                    </div>
                    <div className="py-2 px-4 text-center w-[15%]">
                      <button
                        onClick={() => handleDownload(file)}
                        className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-700"
                      >
                        <CloudDownloadIcon />
                      </button>
                    </div>
                    <div className="py-2 px-4 text-center w-[15%]">
                      <button
                        onClick={() => handleFileDelete(file)} className="bg-red-500 text-white px-2 py-2 rounded hover:bg-red-700"
                      >
                        <FaTrash size={18} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      )
      }
    </div >
  );
};

export default WizardFileUpload;
